/*
Utilities to validate user input.
*/

/**
 * Checks for obvious syntax errors of an email address.
 * @param {string} email
 * @returns {boolean}
 */
export function isEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}
